<div style="width: 100%">
    <div class="filter-container">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="filter-order-nr">
            <mat-label i18n>Order Nr</mat-label>
            <input #orderNrF matInput>
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="filter-project">
            <mat-label i18n>Project</mat-label>
            <input #projectNrF matInput>
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="filter-vendor">
            <mat-label i18n>Vendor</mat-label>
            <input #vendorF matInput>
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="filter-item-descr">
            <mat-label i18n>Item description</mat-label>
            <input #itemDescrF matInput>
        </mat-form-field>

        <mat-slide-toggle #pendingF (change)="storeFilters()">Pending</mat-slide-toggle>
        <mat-slide-toggle #urgentF (change)="storeFilters()">Urgent</mat-slide-toggle>
        <mat-slide-toggle #deliveredF (change)="storeFilters()">Delivered</mat-slide-toggle>
        <mat-slide-toggle #waitingF (change)="storeFilters()">Waiting for Authorization</mat-slide-toggle>
        <button (click)="exportMaterialExcel()" mat-raised-button>Export materials</button>

        @if (canOpenOrder) {
            <span class="add-order">
                <button [routerLink]="['/order/add']" color="accent" mat-fab>
                    <mat-icon>add</mat-icon>
                </button>
            </span>
        }
    </div>

    <div>
        <mat-tab-group (selectedIndexChange)="selectedTab = $event" [selectedIndex]="selectedTab">

            <mat-tab>
                <ng-template mat-tab-label>
                    <span matTooltip="Lista veloce">Orders list</span>
                </ng-template>

                <app-order-list-table [exportRequest]="exportRequest" searchMode='quick'></app-order-list-table>
            </mat-tab>

            <mat-tab>
                <ng-template mat-tab-label>
                    @if (performingSlowSearch$ | async) {
                        <div class="tab-label-loading">
                            <mat-icon matTooltip="Searching...">cloud_sync</mat-icon>
                        </div>
                    } @else {
                        <div class="tab-label-loaded">
                            <mat-icon matTooltip="Lista esaustiva ({{slowListElements}} orders)">cloud_done
                            </mat-icon>
                            <span>({{ slowListElements }})</span>
                        </div>
                    }
                </ng-template>

                <app-order-list-table (updateTotalElements)="slowListElements = $event"
                                      [exportRequest]="exportRequest"
                                      searchMode='slow'></app-order-list-table>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>
